export default __webpack_public_path__ + "static/media/52.9150c854.png";